<mat-menu #addSecurityKey="matMenu" yPosition="below" xPosition="before" class="dropdown-menu-panel">
  @if (mode != 'view' && allowEditPermission) {
  <div id="add-security-search-box" appClickOutside class="search-container">
    @if (securityKeyData?.length) {
    <div class="search-result-continer">
      @for (data of securityKeyData; track data) {
      <div class="search-result-item" (click)="selectSecurityKey($event, data)">
        <div style="display: flex" class="mrr-10px" matTooltip="{{ data?.keyName ? data?.keyName : data?.name }}">
          @if (data.keyName) {
          <div class="form-image-container">
            <mat-icon style="font-size: 18px; padding: 3.5px 2.1px; color: #25508e; position: relative; left: 0px"> vpn_key</mat-icon>
          </div>
          }
          <p style="margin: 12px 0px" class="dropdown-text1 text-truncate">
            <strong>
              {{ data.keyName?.slice(0, 32) | titlecase }}
              {{ data.keyName?.length > 32 ? '...' : '' }}
            </strong>
          </p>
        </div>
        <p style="margin: 12px 0px; min-width: 90px" class="update-at-title"></p>
      </div>
      }
    </div>
    }
  </div>
  }
</mat-menu>
<div class="container" id="add-security-container">
  @if (isDataLoading) {
  <div class="ph-item w-full loader-body-item m-0 p-0 border-0">
    <div class="ph-col-12 p-0 pt-6">
      <div class="ph-row">
        <div class="ph-col-4 h-[10px]"></div>
        <div class="ph-col-6 empty"></div>
        <div class="ph-col-2 h-[10px]"></div>
      </div>
    </div>
  </div>
  } @if (!isDataLoading) {
  <mat-dialog-content class="mat-dialog-content">
    <mat-accordion class="prevent-click" [@.disabled]="true">
      <mat-expansion-panel
        hideToggle
        [disabled]="true"
        [expanded]="true"
        class="parametersPanel"
        style="
          border-bottom-right-radius: 0px;
          border-bottom-left-radius: 0px;
          border-top-right-radius: 0px;
          border-top-left-radius: 0px;
          box-shadow: none;
        "
        [ngClass]="addedSecurityKey?.length == 0 ? 'setEmptyPanelDefault' : ''"
      >
        <mat-expansion-panel-header class="disable_ripple" style="height: 32px !important">
          <mat-panel-title>
            <div class="header-section">
              <p (click)="$event.stopPropagation()" class="text-base m-0 font-bold text-[#010B18]">
                Encryption Key @if (addedSecurityKey?.length) {
                <span> ({{ addedSecurityKey?.length }}) </span>
                }
              </p>
              <button class="app__internal--links--add--btn app__centered-item leading-[34px]" (click)="$event.stopPropagation(); createPremiumKey()">
                <span class="material-icons text-base">add</span>
                <span style="position: relative;"> Add </span>
              </button>
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div>
          @if (!sk) {
          <p class="noFileSection">No encryption key added</p>
          } @if (sk) {
          <div class="folder-view__association-files" style="margin: 9px -24px 0 -24px !important">
            <div class="association-files-table flex fl-col width-100per">
              <div class="width-100per">
                @for (subLink of addedSecurityKey; track subLink; let i = $index) { @if(subLink.sk == sk){
                <div class="association-files-table__body width-100per" style="background: #ffffff">
                  <div style="display: flex; justify-content: space-between">
                    <div
                      class="body-card flex"
                      style="padding: 0px 21px 6px 15px !important; width: 100%; border-radius: 5px; justify-content: space-between"
                    >
                      <div class="test-zeropostion">
                        <div style="display: flex" class="mrr-10px" matTooltip="{{ subLink?.keyName ? subLink?.keyName : subLink?.name }}">
                          @if (!subLink.vault_form_id) {
                          <div class="form-image-container">
                            <mat-icon style="font-size: 18px; color: #25508e; padding: 4px"> vpn_key </mat-icon>
                          </div>
                          }
                          <p class="name-title text-truncate" style="line-height: 36px">
                            {{ subLink?.keyName?.slice(0, 32) | titlecase }}
                            {{ subLink?.keyName?.length > 32 ? '...' : '' }}
                          </p>
                        </div>
                      </div>
                      <div class="last-item">
                        <button
                          class="more-vote-btn"
                          style="position: relative; left: 18px; top: 4px"
                          mat-icon-button
                          [matMenuTriggerFor]="menuItem"
                          [disableRipple]="true"
                        >
                          @if (mode != 'view') {
                          <span class="material-icons">more_vert</span>
                          }
                        </button>
                        <mat-menu #menuItem="matMenu" yPosition="below" xPosition="before" class="popup-menu-panel">
                          @if (!isRemoveEditSaveSharing && mode != 'view') {
                          <button mat-menu-item class="popup-menu-item remove-link" style="color: #ff0000">
                            <span class="material-icons menuitem-icon text-[16px] text-[#ff0000]">delete</span>
                            <span style="position: relative; top: -3px; left: 8px" (click)="askConfirmation($event, subLink)"> Remove Link </span>
                          </button>
                          }
                        </mat-menu>
                      </div>
                    </div>
                  </div>
                </div>

                } }
              </div>
            </div>
          </div>
          }
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </mat-dialog-content>
  }
</div>
